import { atom } from 'recoil';
import { Environment } from '~/engine/data/Environment';
import { ViewManager } from '~/engine/view/ViewManager';
import { PlaneView } from '~/engine/view/views/PlaneView';

export const environmentState = atom<Environment | null>({
    key: 'environmentState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const secondaryEnvironmentState = atom<Environment | null>({
    key: 'secondaryEnvironmentState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const viewManagerState = atom<ViewManager | null>({
    key: 'viewManagerState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const mainViewState = atom<PlaneView | null>({
    key: 'mainViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const upperSideViewState = atom<PlaneView | null>({
    key: 'upperSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const lowerSideViewState = atom<PlaneView | null>({
    key: 'lowerSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const secondaryMainViewState = atom<PlaneView | null>({
    key: 'secondaryMainViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const secondaryUpperSideViewState = atom<PlaneView | null>({
    key: 'secondaryUpperSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const secondaryLowerSideViewState = atom<PlaneView | null>({
    key: 'secondaryLowerSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});
